import type { AppState } from '~/store/app.store';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';

export const activeDataLayersBTGIdPerBoundaryGroupToolsStateSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.dataLayers.activeBTGIdPerBoundaryGroup;
};
